// Helper functions to debug auth token issues

// Check and log the current state of the auth token
export const debugAuthToken = () => {
  const token = localStorage.getItem('authToken');
  const tokenInfo = token ? {
    exists: true,
    length: token.length,
    firstChars: token.substring(0, 5) + '...',
    lastChars: '...' + token.substring(token.length - 5),
    isExpired: checkIfExpired(token)
  } : {
    exists: false
  };

  return tokenInfo;
};

// Check if a token is expired
export const checkIfExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= expirationTime;
  } catch (error) {

    return true; // Assume expired if we can't parse it
  }
};

// A more robust version of getToken that tries multiple keys
export const getAuthToken = () => {
  // Try authToken (primary storage key)
  let token = localStorage.getItem('authToken');
  
  // If not found, try alternative keys
  if (!token) {
    token = localStorage.getItem('authToken');
    
    // If found in alternative location, migrate it
    if (token) {

      localStorage.setItem('authToken', token);
    }
  }
  
  return token;
};
